import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { withRouter } from '~HOC';
import '@mobiscroll/react/dist/css/mobiscroll.react.min.css';
import {
  Datepicker,
  Page,
  setOptions,
  localeFa,
  localeEn,
} from '@mobiscroll/react';
import './dropDownDatePicker.scss';
import { CalendarIcon } from '~svg/index';
import * as moment from 'moment';
// -----------------
// import { changeLanguage } from "../../../actions/language";

setOptions({
  locale: localeFa,
  theme: 'ios',
  themeVariant: 'light',
});

const DropDownDatePicker = (props) => {
  useEffect(() => {
    var datePickerLabel = document.getElementsByClassName(
      'md-mobile-picker-box-label',
    )[0];
    datePickerLabel.id = 'datePickerLabel';
    var textBoxDatePicker =
      document.getElementsByClassName('mbsc-textfield-box')[0];
    textBoxDatePicker.id = textBoxDatePicker;
  });
  const { hideMiladi = false } = props;
  const [localeName, setLocaleName] = React.useState(props.localeName);
  const [changeToMialdi, setChangeToMiladi] = React.useState(
    props.localeName === 'fa' ? false : true,
  );
  const [custom, setCustom] = React.useState(props.value);
  const customButtons = React.useMemo(() => {
    return [
      {
        //  text: '05 Jan 2020',
        handler: () => {
          custom.setVal(new Date(date));
          custom.close();
        },
      },
      'set',
      'cancel',
    ];
  }, [custom]);
  useEffect(() => {
    setCustom(props.value);
  }, [props.value]);
  const boxInputProps = {
    className: 'md-mobile-picker-box-label px-3 font-normal w-100 ',
    inputStyle: 'box w-100 ',
    placeholder: '',
  };

  return (
    <Page>
      <div
        className={`mbsc-grid bg-transparent w-100 px-0 ${props.bodyClass} `}
      >
        <span
          style={{
            // fontFamily: "vazir",
            fontFamily:
              props.language.direction === 'ltr' ? 'GothamLight' : 'vazir',
            fontWeight: props.language.direction === 'ltr' ? 'lighter' : '',
            color: props.language.direction === 'ltr' ? '#4b5056' : 'black',
          }}
          className={`d-flex w-100 font-small  px-3 
         ${
           props.language.direction === 'ltr'
             ? 'justify-content-end'
             : 'justify-content-start'
         }
        
          ${custom || props.value ? '' : props.fontStyle} 
          ${props.fontStyle ? props.fontStyle : 'font-small'} `}
        >
          {/*  ${custom || props.value ? "text-success" : props.fontStyle}  */}
          {props.intl.formatMessage({ id: `booking.${props.label}` })}
        </span>
        <div className="mbsc-form-group m-0 p-0 bg-transparent ">
          <div className="mbsc-row  bg-transparent ">
            <div
              className="mbsc-col-12 px-0 w-100  bg-transparent "
              style={{
                fontFamily:
                  props.language.direction === 'ltr' ? 'GothamLight ' : 'vazir',
              }}
            >
              <div
                style={{
                  position: 'absolute',
                  top: '40%',
                  right: props.localeName === 'fa' ? '34px' : '',
                  left: props.localeName === 'en' ? '34px' : '',
                  zIndex: 4,
                }}
                className={`d-flex ${props.iconStyle}`}
              >
                <CalendarIcon color="#00798c" />
              </div>
              <Datepicker
                defaultSelection={new Date(props.max).setFullYear(
                  new Date(props.max).getFullYear() - 1,
                )}
                controls={['date']}
                buttons={customButtons}
                dateFormat="YYYY-MM-DD"
                dateWheels="DD MMM YYYY"
                min={props.min}
                max={props.max}
                themeVariant={props.theme}
                value={custom || props.value}
                rtl={props.localeName === 'fa' ? true : false}
                inputProps={boxInputProps}
                locale={localeName === 'fa' ? localeFa : localeEn}
                onChange={(event, inst) => {
                  setCustom(event.value);
                  props.getSelectedDate(event.value);
                }}
                touchUi={props.touchUi}
                moment={moment}
                returnFormat="moment"
              />
              {props.localeName === 'fa' && (
                <div
                  style={{
                    position: 'absolute',
                    top: '39%',
                    // left: 16,
                    left: props.localeName === 'fa' ? '16px' : '',
                    right: props.localeName === 'en' ? '16px' : '',
                    fontFamily:
                      props.language.direction === 'ltr'
                        ? 'GothamLight'
                        : 'vazir',
                  }}
                  className={`d-flex col-4 col-sm-5 col-md-4 px-2  justify-content-end align-items-center font-small  text-captalize `}
                >
                  <div
                    className={`px-1 font-msmall d-flex justify-content-center ${
                      !changeToMialdi ? 'text-secondary' : 'text-third'
                    } underline `}
                    onClick={() => {
                      setChangeToMiladi(false);
                      setLocaleName('fa');
                    }}
                  >
                    <FormattedMessage
                      id="booking.shamsiShamsi"
                      defaultMessage="booking.shamsiShamsi"
                    />
                  </div>
                  <div className="d-flex text-third ">/</div>
                  <div
                    className={`px-1 d-flex font-msmall justify-content-center   ${
                      changeToMialdi ? 'text-secondary' : 'text-third'
                    } underline`}
                    onClick={() => {
                      setChangeToMiladi(true);
                      setLocaleName('en');
                    }}
                  >
                    <FormattedMessage
                      id="booking.miladi"
                      defaultMessage="booking.miladi"
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Page>
  );
};
DropDownDatePicker.propTypes = {
  theme: PropTypes.oneOf(['dark', 'light', 'outo']),
  localeName: PropTypes.string,
  min: PropTypes.string,
  max: PropTypes.string,
  label: PropTypes.string,
  touchUi: PropTypes.bool,
  value: PropTypes.string,
  getSelectedDate: PropTypes.func,
  bodyClass: PropTypes.string,
  fontStyle: PropTypes.string,
  iconStyle: PropTypes.string,
  // textBoxDatePicker: PropTypes.string,
};
DropDownDatePicker.defaultProps = {
  theme: 'auto',
  localeName: 'en',
  min: '1920-01-01',
  max: '2050-01-01',
  label: '',
  touchUi: false,
  value: '',
  getSelectedDate: () =>
    console.error('There is not any function for getSelectedDate'),
  bodyClass: '',
  fontStyle: '',
  iconStyle: '',
  // textBoxDatePicker: "",
};
function mapStateToProps(state, props) {
  return {
    language: state.language,
  };
}
export default injectIntl(
  connect(mapStateToProps)(withRouter(DropDownDatePicker)),
);
